import React, { Component } from 'react'
import EventEditModalUI from './EventEditModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class EventEditModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      adminApprovalRequired: '',
      reminderIteration: '',
      statusError: null,
      adminApprovalRequiredError: null,
      reminderIterationError: null,
      successMsg: null,
      errorList: [],
      submitted: false
    }
  }

  componentDidUpdate(prevProps) {
    // Initialize form when modal opens with selected event data
    if (this.props.editMode && !prevProps.editMode && this.props.selectedEvent) {
      const { status, adminApprovalRequired, reminderIteration } = this.props.selectedEvent
      this.setState({
        status: status || '',
        adminApprovalRequired: adminApprovalRequired ? 'Yes' : 'No',
        reminderIteration: reminderIteration || '',
        statusError: null,
        adminApprovalRequiredError: null,
        reminderIterationError: null,
        successMsg: null,
        errorList: [],
        submitted: false
      })
    }
  }

  handleStatusChange = (e) => {
    this.setState({ 
      status: e.target.value,
      statusError: null 
    })
  }

  handleAdminApprovalRequiredChange = (e) => {
    this.setState({ 
      adminApprovalRequired: e.target.value,
      adminApprovalRequiredError: null 
    })
  }

  handleReminderIterationChange = (e) => {
    this.setState({ 
      reminderIteration: e.target.value,
      reminderIterationError: null 
    })
  }

  validateForm = () => {
    let isValid = true
    
    if (!this.state.status) {
      this.setState({ statusError: 'Status is required' })
      isValid = false
    }
    
    if (!this.state.adminApprovalRequired) {
      this.setState({ adminApprovalRequiredError: 'Admin Approval Required selection is required' })
      isValid = false
    }
    
    if (!this.state.reminderIteration) {
      this.setState({ reminderIterationError: 'Reminder Iteration is required' })
      isValid = false
    } else if (parseInt(this.state.reminderIteration) < 1) {
      this.setState({ reminderIterationError: 'Reminder Iteration must be at least 1' })
      isValid = false
    }
    
    return isValid
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!this.validateForm()) {
      return
    }
    
    this.setState({ submitted: true, errorList: [] })
    
    try {
      // Format data for API according to required payload
      const payload = {
        isActive: this.state.status === 'Active',
        requiresApproval: this.state.adminApprovalRequired === 'Yes',
        iteration: parseInt(this.state.reminderIteration)
      }
      
      // Call the API using RestApiUtils
      RestApiUtils.post(
        this.props.context,
        '/api/notifyEvent/updateNotifyEvent/'+this.props.selectedEvent.id,
        (response) => {
          if (response.success) {
            // Call the onEventUpdated callback to update the parent component
            this.props.onEventUpdated({
              ...this.props.selectedEvent,
              status: this.state.status,
              adminApprovalRequired: this.state.adminApprovalRequired === 'Yes',
              reminderIteration: parseInt(this.state.reminderIteration)
            })
            
            this.setState({ 
              successMsg: 'Event updated successfully',
              submitted: false
            })
            
            // Close modal after a short delay
            setTimeout(() => {
              this.props.onCancel() 
            }, 1000)
          } else {
            // Handle API error
            this.setState({ 
              errorList: response.errorList || ['Failed to update event. Please try again.'],
              submitted: false
            })
          }
        },
        payload
      )
    } catch (error) {
      this.setState({ 
        errorList: ['Failed to update event. Please try again.'],
        submitted: false
      })
      console.error('Error updating event:', error)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }

  render() {
    const { messageList = [] } = this.props;
    
    return (
      <EventEditModalUI
        context={this.props.context}
        messageList={messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        
        editMode={this.props.editMode}
        submitted={this.state.submitted}
        
        status={this.state.status}
        onStatusChange={this.handleStatusChange}
        statusError={this.state.statusError}
        setStatusError={(error) => this.setState({ statusError: error })}
        
        adminApprovalRequired={this.state.adminApprovalRequired}
        onAdminApprovalRequiredChange={this.handleAdminApprovalRequiredChange}
        adminApprovalRequiredError={this.state.adminApprovalRequiredError}
        setAdminApprovalRequiredError={(error) => this.setState({ adminApprovalRequiredError: error })}
        
        reminderIteration={this.state.reminderIteration}
        onReminderIterationChange={this.handleReminderIterationChange}
        reminderIterationError={this.state.reminderIterationError}
        setReminderIterationError={(error) => this.setState({ reminderIterationError: error })}
        
        onSubmit={this.handleSubmit}
        onCancelClick={this.props.onCancel}
      />
    )
  }
}

export default EventEditModalSF
